import { render, staticRenderFns } from "./DocumentsBlock.vue?vue&type=template&id=f93d9e80&scoped=true&"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js&"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsBlock.vue?vue&type=style&index=0&id=f93d9e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93d9e80",
  null
  
)

export default component.exports